import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'department_general_info';
export const useDepartmentGeneralInfoTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return (useTranslation(namespace, { keyPrefix }));
};
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    fields: {
      name: 'Название',
      description: 'Описание',
      created: 'Создано',
      updated: 'Изменено',
    },
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    fields: {
      name: 'Name',
      description: 'Description',
      created: 'Created',
      updated: 'Updated',
    },
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      created: 'Creado',
      updated: 'Actualizado',
    },
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    fields: {
      name: 'Nome',
      description: 'Descrição',
      created: 'Criado',
      updated: 'Atualizado',
    },
  },
}) : {}) as Record<string, unknown>;
